import { mapGetters } from 'vuex';
import { TagColors } from '@/components/tag/tag.enums';
import { RnHeader, RnButton, RnPagination, RnNewTable, RnOrderPlanner, RnTag } from '@/components';
import RnSpinner from '@/components/spinner/spinner.vue';
import { ITEMS_PER_PAGE } from '@/services/constants';
import { formatAsDate } from '@/utils/format-as-date';

export default {
	name: 'rn-cp-dashboard-view',
	components: {
		RnSpinner,
		RnHeader,
		RnButton,
		RnPagination,
		RnNewTable,
		RnOrderPlanner,
		RnTag,
		TagColors,
	},
	data() {
		return {
			ITEMS_PER_PAGE: ITEMS_PER_PAGE.DEFAULT,
			collectionOrdersTableHeaders: [
				{
					text: this.$t('table.order.status'),
					value: 'status',
					component: RnTag,
					compact: true,
					componentProps: value => {
						if (!value.status) {
							return null;
						}

						return {
							text: this.$t(`table.order.status.${value.status}`),
							color: TagColors[value.status.toLowerCase()],
						};
					},
				},
				{
					text: this.$t('table.order.number'),
					value: 'number',
					compact: true,
				},
				{
					text: this.$t('table.order.dateRequested'),
					value: 'orderCreationDate',
					customSort: 'date',
					compact: true,
					display: formatAsDate,
				},
				{
					text: this.$t('table.order.dateCollection'),
					value: 'pickUpDate',
					customSort: 'date',
					compact: true,
					display: formatAsDate,
				},
				{
					text: this.$t('common.collectionPoint'),
					value: 'sourceLocation.name',
				},
				{
					text: '',
					align: 'end',
					component: RnButton,
					sortable: false,
					componentProps: ({ id }) => ({
						color: 'blue',
						method: () => {
							this.planCollection(id);
						},
						outline: true,
						disableWrap: true,
						size: 'x-small',
						text: this.$t('common.planCollection'),
					}),
				},
			],
			collectionOrdersPaginated: undefined,
			page: 0,
		};
	},
	computed: {
		...mapGetters(['userName', 'businessRelationId', 'incomingUnplannedCollectionOrders', 'incomingUnplannedCollectionOrdersCount', 'locations']),
		locationIds: () => (this.locations || []).map(location => location.id),
		collectionOrdersState() {
			if (!this.incomingUnplannedCollectionOrders) {
				return 'loading';
			}
			if (this.incomingUnplannedCollectionOrders.length) {
				return 'results';
			}
			return 'noResults';
		},
	},
	created() {
		this.updateCollectionOrdersPaginated(0);
	},
	methods: {
		planTransport() {
			this.$router.push({ name: 'CPNewTransport' });
		},
		planCollection(collectionOrderId) {
			this.$router.push({ name: 'CPNewCollection', params: { collectionOrderId } });
		},
		updateCollectionOrdersPaginated(page) {
			this.page = page;
			this.$store.dispatch('getIncomingUnplannedCollectionOrders', {
				businessRelationId: this.businessRelationId,
				page: page || 0,
				pageSize: this.ITEMS_PER_PAGE,
			});
		},
	},
};
